import React from 'react';

import { UsersUser } from '../user/UsersUser';
import * as Styled from './StyledUsers';

export const Users = ({ users, t }) => (
    <Styled.Users>
        <Styled.UsersThead>
            <Styled.UsersTr>
                <Styled.UsersTh>
                    {t('dashboard.Users.user')} ({users.length})
                </Styled.UsersTh>
                <Styled.UsersTh>{t('dashboard.Users.rank')}</Styled.UsersTh>
                <Styled.UsersTh>{t('dashboard.Users.stage')}</Styled.UsersTh>
                <Styled.UsersTh>{t('dashboard.Users.points')}</Styled.UsersTh>
                <Styled.UsersTh>{t('dashboard.Users.pointsOnline')}</Styled.UsersTh>
                <Styled.UsersTh>{t('dashboard.Users.pointsSpeedDatings')}</Styled.UsersTh>
                <Styled.UsersTh>{t('dashboard.Users.pointsMentorship')}</Styled.UsersTh>
                <Styled.UsersTh>{t('dashboard.Users.matches')}</Styled.UsersTh>
                <Styled.UsersTh>{t('dashboard.Users.positive')}</Styled.UsersTh>
            </Styled.UsersTr>
        </Styled.UsersThead>

        <Styled.UsersTbody>
            {users.map(user => {
                let stage = '100';
                if (user.cxiStats.currentStage === 2) stage = '10';
                if (user.cxiStats.currentStage === 3) stage = '1';

                const feedbacksPositive =
                    (user.cxiStats?.metrics?.stage1?.feedbacksPositive ?? 0) +
                    (user.cxiStats?.metrics?.stage2?.feedbacksPositive ?? 0) +
                    (user.cxiStats?.metrics?.stage3?.feedbacksPositive ?? 0);

                return (
                    <tr key={user._id}>
                        <td>
                            <UsersUser user={user} />
                        </td>
                        <td>{user.rank ? `${user.rank}º` : 'N/A'}</td>
                        <td>{stage}</td>
                        <td>{user.cxiStats?.metrics?.points ?? 0}</td>
                        <td>{user.cxiStats?.metrics?.stage1?.feedbacksPositive ?? 0}</td>
                        <td>{user.cxiStats?.metrics?.stage2?.feedbacksPositive ?? 0}</td>
                        <td>{user.cxiStats?.metrics?.stage3?.feedbacksPositive ?? 0}</td>
                        <td>{user.cxiStats?.metrics?.matches ?? 0}</td>
                        <td>{feedbacksPositive}</td>
                    </tr>
                );
            })}
        </Styled.UsersTbody>
    </Styled.Users>
);
